import React, { useEffect, useState } from 'react';
import TopHotels from 'components/BusinessLogic/TopHotels/Card';
import TopDestinations from 'components/BusinessLogic/TopDestinations/Card';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import Title from 'components/UI/Title';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import Summary from 'components/UI/Summary';
import _, { get, sumBy } from 'lodash';
import currencyFormat from 'utils/currency-format';
import { connect } from 'react-redux';
import { loadNumberOfBookings, loadSales } from 'store/dispatchers/memberReports.dispatchers';
import { buildReportsSelector } from 'store/selectors/memberReports.selector';

function Reports({
    isB2cPage, getNumberOfBookings, storedBookingsReport,
})
{
    const [bookingReport, setBookingReport] = useState({
        currentYearSalesAvg: '',
        currentYearBookings: '',
        salesAvgPercentageDiff: '',
        bookingsPercentageDiff: '',
        bookingsBalance: 0,
        salesAvgBalance: 0,
    });

    const fillBookingsReport = (bookingData) =>
    {
        const lastYearData = get(bookingData, '0', []) || [];
        const currentYearData = get(bookingData, '1', []) || [];

        const lastYearSalesAvg = sumBy(lastYearData, 'gross') / lastYearData.length;
        const currentYearSalesAvg = sumBy(currentYearData, 'gross') / currentYearData.length;

        const salesDiff = currentYearSalesAvg - lastYearSalesAvg;
        const bookingsDiff = currentYearData.length - lastYearData.length;

        setBookingReport({
            currentYearSalesAvg,
            currentYearBookings: currentYearData.length.toString(),
            salesAvgPercentageDiff: lastYearSalesAvg ? (salesDiff / lastYearSalesAvg) * 100 : 0,
            bookingsPercentageDiff: lastYearData.length ? (bookingsDiff / lastYearData.length) * 100 : 0,
            bookingsBalance: bookingsDiff,
            salesAvgBalance: salesDiff,
        });
    };

    const loadReportBookings = () =>
    {
        if (!_.isEmpty(storedBookingsReport))
        {
            fillBookingsReport(storedBookingsReport.data);
            return;
        }

        getNumberOfBookings();
    };

    useEffect(() =>
    {
        loadReportBookings();
    }, [storedBookingsReport]);

    return (
        <div className="tw-flex tw-flex-col tw-flex-1 tw-w-full h-full tw-overflow-y-auto tw-p-10  lg:tw-pl-[248px] ">
            <Title title="Reports" margin="tw-mb-3 max-sm:tw-mt-10 tw-mt-5" icon={faChartBar} />

            <Summary
                title="Number of Bookings"
                subtitle="Last 360 Days"
                compareTitle="Compared Year-over-Year"
                isLoading={bookingReport.currentYearBookings === ''}
                total={bookingReport.currentYearBookings}
                compareTotal={`${currencyFormat(bookingReport.bookingsPercentageDiff, 2, null)}%`}
                balance={bookingReport.bookingsBalance}
            />

            <div className="tw-flex-row tw-flex tw-gap-3 max-xl:tw-flex-col">
                <TopHotels />
                <TopDestinations />
            </div>

            <Helmet title={`Reports | ${isB2cPage ? 'Luxuria Vacations' : 'UJV'}`}>
                <meta name="description" content="Reports" />
            </Helmet>
        </div>
    );
}

Reports.defaultProps = {
    isB2cPage: false,
};

Reports.propTypes = {
    isB2cPage: PropTypes.bool,
    getNumberOfBookings: PropTypes.func,
    storedBookingsReport: PropTypes.object,
};

const mapStateToProps = () =>
{
    const reportSelector = buildReportsSelector();

    return (state) => ({
        storedBookingsReport: reportSelector(state, 'bookings_report'),
    });
};

const mapDispatchToProps = (dispatch) => ({
    getNumberOfBookings()
    {
        return dispatch(loadNumberOfBookings());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Reports);
